import { useCallback } from 'react';
import { request, isDebankUrl, openNewWindow } from 'utils';
import { openExternalLinkModal } from '@/components';

type UrlCheckType = 'forbidden' | 'warning' | 'safe';

export const checkUrl = (url: string) => {
  return request
    .get<{ level: UrlCheckType; msg?: string }>('/origin/check', { url })
    .catch(() => ({ level: 'warning', msg: '' }));
};

export const useUrl = () => {
  const checkAndOpenUrl = useCallback(async (url: string, openCallback?: () => void) => {
    if (isDebankUrl(url)) {
      openCallback && openCallback();
      openNewWindow(url, '_blank');
      return;
    }
    const { level, msg } = await checkUrl(url);

    switch (level) {
      case 'forbidden':
      case 'warning':
        openExternalLinkModal({ link: url, level, description: msg, openCallback });
        break;
      case 'safe':
      default:
        openCallback && openCallback();
        openNewWindow(url, '_blank');
    }
  }, []);

  return {
    checkAndOpenUrl,
  };
};
